/** English UI strings for @reyka/openpolotno (defaults are Russian). */
export const englishTranslations = {
  toolbar: {
    duration: 'Duration',
    opacity: 'Opacity',
    effects: 'Effects',
    blur: 'Blur',
    curvedText: 'Curved text',
    curvePower: 'Curve power',
    temperature: 'Temperature',
    saturation: 'Saturation',
    contrast: 'Contrast',
    shadows: 'Shadows',
    white: 'White',
    black: 'Black',
    vibrance: 'Vibrance',
    textBackground: 'Background',
    backgroundCornerRadius: 'Corner radius',
    backgroundOpacity: 'Opacity',
    backgroundPadding: 'Padding',
    brightness: 'Brightness',
    filters: 'Filters',
    sepia: 'Sepia',
    grayscale: 'Grayscale',
    textStroke: 'Text stroke',
    shadow: 'Shadow',
    border: 'Border',
    cornerRadius: 'Corner radius',
    cornerRadiusMixed: 'Mixed',
    cornerRadiusIndependent: 'Independent corners',
    cornerRadiusTopLeft: 'Top-left',
    cornerRadiusTopRight: 'Top-right',
    cornerRadiusBottomLeft: 'Bottom-left',
    cornerRadiusBottomRight: 'Bottom-right',
    copyStyle: 'Copy style',
    uppercase: 'Uppercase',
    position: 'Position',
    layering: 'Layer order',
    toForward: 'Bring to front',
    up: 'Bring forward',
    down: 'Send backward',
    toBottom: 'Send to back',
    alignLeft: 'Align left',
    alignCenter: 'Align center',
    alignRight: 'Align right',
    alignTop: 'Align top',
    alignMiddle: 'Align middle',
    alignBottom: 'Align bottom',
    flip: 'Flip',
    flipHorizontally: 'Flip horizontally',
    flipVertically: 'Flip vertically',
    fitToBackground: 'Fit to page',
    removeBackground: 'Remove background',
    removeBackgroundTitle: 'Remove image background',
    cancelRemoveBackground: 'Cancel',
    confirmRemoveBackground: 'Confirm',
    crop: 'Crop',
    cropDone: 'Done',
    cropCancel: 'Cancel',
    clip: 'Apply mask',
    removeClip: 'Remove mask',
    removeMask: 'Remove mask',
    transparency: 'Transparency',
    lockedDescription: 'Object is locked. Unlock it to edit on the canvas.',
    unlockedDescription: 'Object is unlocked. Lock it to prevent canvas edits.',
    removeElements: 'Delete elements',
    duplicateElements: 'Duplicate elements',
    download: 'Download',
    saveAsImage: 'Save as image',
    saveAsPDF: 'Save as PDF',
    lineHeight: 'Line height',
    letterSpacing: 'Letter spacing',
    offsetX: 'Offset X',
    offsetY: 'Offset Y',
    color: 'Color',
    selectable: 'Selectable',
    draggable: 'Draggable',
    removable: 'Removable',
    resizable: 'Resizable',
    contentEditable: 'Content editable',
    styleEditable: 'Style editable',
    alwaysOnTop: 'Always on top',
    showInExport: 'Show in export',
    ungroupElements: 'Ungroup',
    groupElements: 'Group',
    lineSize: 'Line width',
    fade: 'Fade',
    move: 'Move',
    zoom: 'Zoom',
    animate: 'Animate',
    rotate: 'Rotate',
    none: 'None',
    bounce: 'Bounce',
    blink: 'Blink',
    strength: 'Strength',
    spaceEvenly: 'Space evenly',
    horizontalDistribution: 'Horizontal',
    verticalDistribution: 'Vertical',
    strokeWidth: 'Stroke width',
    cold: 'Cold',
    warm: 'Warm',
    natural: 'Natural',
    colorPicker: {
      solid: 'Solid',
      linear: 'Linear',
      angle: 'Angle',
      radial: 'Radial',
      pattern: 'Pattern',
      customImage: 'Custom image',
      useImageAsPattern: 'Use this image as a pattern',
      uploadImageFormats: 'Upload image (JPG, PNG, SVG)',
      upload: 'Upload',
      foreground: 'Foreground',
      background: 'Background',
      scale: 'Scale',
    },
    blendMode: {
      title: 'Blend mode',
      groups: {
        normal: 'Normal',
        darken: 'Darken',
        lighten: 'Lighten',
        contrast: 'Contrast',
        inversion: 'Inversion',
        component: 'Component',
        compositing: 'Compositing',
      },
      modes: {
        normal: 'Normal',
        darken: 'Darken',
        multiply: 'Multiply',
        colorBurn: 'Color burn',
        lighten: 'Lighten',
        screen: 'Screen',
        colorDodge: 'Color dodge',
        linearDodge: 'Linear dodge (add)',
        overlay: 'Overlay',
        softLight: 'Soft light',
        hardLight: 'Hard light',
        difference: 'Difference',
        exclusion: 'Exclusion',
        xor: 'XOR',
        hue: 'Hue',
        saturation: 'Saturation',
        colorMix: 'Color',
        luminosity: 'Luminosity',
        copySourceOnly: 'Copy (source only)',
        destinationOver: 'Destination over',
        sourceIn: 'Source in',
        sourceOut: 'Source out',
        sourceAtop: 'Source atop',
        destinationIn: 'Destination in',
        destinationOut: 'Destination out',
        destinationAtop: 'Destination atop',
      },
    },
    aiText: {
      aiWrite: 'AI write',
      rewrite: 'Rewrite',
      shorten: 'Shorten',
      continue: 'Continue',
      proofread: 'Proofread',
      tones: 'Tone',
      friendly: 'Friendly',
      professional: 'Professional',
      humorous: 'Humorous',
      formal: 'Formal',
      customPrompt: 'Custom prompt',
      generatedResult: 'Result',
      cancel: 'Cancel',
      generate: 'Generate',
      back: 'Back',
      tryAgain: 'Try again',
      insert: 'Insert',
      promptPlaceholder: 'Describe what to generate',
    },
  },
  workspace: {
    noPages: 'No pages yet...',
    addPage: 'Add page',
    removePage: 'Remove page',
    duplicatePage: 'Duplicate page',
    moveUp: 'Move up',
    moveDown: 'Move down',
  },
  scale: { reset: 'Reset' },
  error: { removeBackground: 'Something went wrong. Could not remove the background.' },
  sidePanel: {
    templates: 'Templates',
    searchTemplatesWithSameSize: 'Same size templates',
    catalogGlobal: 'Global',
    catalogProject: 'Project',
    searchPlaceholder: 'Search...',
    otherFormats: 'Other formats',
    noResults: 'No results',
    error: 'Failed to load...',
    text: 'Text',
    uploadFont: 'Upload font',
    myFonts: 'My fonts',
    photos: 'Photos',
    videos: 'Videos',
    animations: 'Animations',
    effects: 'Effects',
    elements: 'Elements',
    shapes: 'Shapes',
    lines: 'Lines',
    elementAssetsLight: 'SVG assets — light',
    elementAssetsDark: 'SVG assets — dark',
    upload: 'Upload',
    uploadImage: 'Add file',
    uploadTip: 'Upload your own media',
    background: 'Background',
    resize: 'Resize',
    layers: 'Layers',
    animate: 'Animate',
    layerTypes: {
      image: 'Image',
      text: 'Text',
      svg: 'SVG',
      line: 'Line',
      figure: 'Shape',
      group: 'Group',
    },
    layersTip: 'Elements on the active page:',
    noLayers: 'No elements on this page...',
    namePlaceholder: 'Element name...',
    useMagicResize: 'Magic resize',
    clipImage: 'Image mask',
    width: 'Width',
    height: 'Height',
    magicResizeDescription: 'Magic resize scales and repositions every element on the canvas',
    units: 'Units',
    photosBy: 'Photos by ',
    photosByOn: ' on ',
    headerText: 'Heading',
    createHeader: 'Add heading',
    subHeaderText: 'Subheading',
    createSubHeader: 'Add subheading',
    bodyText: 'Body text',
    createBody: 'Add body text',
    aiImagesIntro:
      'Stable Diffusion generates images from text prompts. Describe what you want to create.',
    aiImagesPlaceholder: 'Describe an image to generate…',
    aiImagesGenerate: 'Generate',
    aiImagesError: 'Something went wrong. Try again later.',
    sampleCoolText: 'Cool text',
    videoCatalog: 'Videos — ',
    videoCreditBy: 'Video by ',
    deleteTemplateTitle: 'Delete template?',
    deleteTemplateMessage: 'Template “{{id}}” will be removed from the project. This cannot be undone.',
    deleteTemplateConfirm: 'Delete',
    deleteTemplateCancel: 'Cancel',
  },
  pagesTimeline: {
    pages: 'Pages',
    removePage: 'Remove page',
    addPage: 'Add page',
    duplicatePage: 'Duplicate page',
    removeAudio: 'Remove audio',
    zoomTimeline: 'Zoom timeline',
  },
  contextMenu: {
    duplicate: 'Duplicate',
    remove: 'Delete',
    lock: 'Lock',
    unlock: 'Unlock',
    copy: 'Copy',
    paste: 'Paste',
    copyStyle: 'Copy style',
    moveUp: 'Move up',
    moveDown: 'Move down',
    moveBack: 'Send to back',
    moveForward: 'Bring forward',
  },
  shortcuts: {
    tooltip: 'Keyboard shortcuts (?)',
    dialogTitle: 'Keyboard shortcuts',
    categories: {
      edit: 'Edit',
      addElements: 'Add elements',
      move: 'Move',
      zoom: 'Zoom',
      align: 'Align (multiple objects)',
      layers: 'Layers',
    },
    undo: 'Undo',
    redo: 'Redo',
    copy: 'Copy',
    cut: 'Cut',
    paste: 'Paste',
    selectAll: 'Select all',
    duplicate: 'Duplicate',
    deleteSelected: 'Delete selection',
    groupUngroup: 'Group / ungroup',
    addText: 'Add text',
    addRectangle: 'Add rectangle',
    addCircle: 'Add circle',
    addLine: 'Add line',
    nudge1px: 'Nudge 1 px',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    alignLeft: 'Align left',
    alignRight: 'Align right',
    alignTop: 'Align top',
    alignBottom: 'Align bottom',
    centerHorizontally: 'Center horizontally',
    centerVertically: 'Center vertically',
    moveUpLayer: 'Layer up',
    moveDownLayer: 'Layer down',
    bringToFront: 'Bring to front',
    sendToBack: 'Send to back',
  },
  onboarding: {
    welcomeTitle: 'Welcome to Design Studio 👋',
    welcomeDesc: 'A quick tour of the essentials — about 30 seconds.',
    sidePanelTitle: 'Add elements',
    sidePanelDesc: 'Use the side panel to add text, photos, shapes, video, and more.',
    canvasTitle: 'Canvas',
    canvasDesc: 'Your design lives here. Click an element to select it, then drag or resize.',
    toolbarTitle: 'Editing toolbar',
    toolbarDesc: 'When something is selected, fonts, colors, blend modes, effects, filters, and animations appear here.',
    exportTitle: 'Export',
    exportDesc: 'When you are ready, download PNG, JPG, PDF, SVG, or video.',
    doneTitle: 'You are set! 🎉',
    doneDesc: 'Add elements from the left and edit them on the canvas. Have fun!',
    back: 'Back',
    next: 'Next →',
    getStarted: 'Get started',
    skipTour: 'Skip tour',
  },
  presentation: {
    title: 'Slideshow',
    navHints: '{{current}} / {{total}}  ·  ← → navigate  ·  space — next  ·  Esc — exit',
    fullscreen: 'Fullscreen (F)',
    exitFullscreen: 'Exit fullscreen (F)',
    exitEsc: 'Exit (Esc)',
    presentTooltip: 'Present slideshow',
    slideFailed: 'Could not render slide',
    slideAria: 'Slide {{n}}',
  },
  historyUi: {
    tooltip: 'History',
    initialState: 'Initial state',
    addedPage: 'Page added',
    removedPage: 'Page removed',
    resizedCanvas: 'Canvas resized',
    addedOneElement: 'Element added',
    addedNElements: 'Elements added: {{n}}',
    removedOneElement: 'Element removed',
    removedNElements: 'Elements removed: {{n}}',
    replacedElements: 'Elements replaced',
    modified: 'Modified',
    empty: 'No history yet.',
    stepsHeader: 'History entries: {{count}}',
    stepLabel: 'Step {{n}}',
    current: 'Current',
    now: 'Now',
    sidePanelStepCount: 'Entries: {{count}}',
  },
  rulers: {
    show: 'Show rulers and guides',
    hide: 'Hide rulers and guides',
  },
  advancedSelect: {
    tooltip: 'Advanced selection',
    divider: 'Select on page…',
    sameType: 'Same type ({{type}})',
    sameColor: 'Same color',
    sameFont: 'Same font ({{font}})',
  },
  download: {
    saveAsGif: 'Save as GIF',
    saveAsVideo: 'Save as video',
    exportGifFailed: 'GIF export failed. Try again.',
    exportVideoFailed: 'Video export failed. Try again.',
  },
  canvas: {
    imageLoadError: 'Could not load image…',
    gifLoadError: 'Could not load GIF…',
    videoLoadError: 'Could not load video…',
    rendering: 'Rendering…',
    guideHint: 'Drag to move • double-click to delete',
  },
  drawPanel: {
    tool: 'Tool',
    selection: 'Selection',
    brush: 'Brush',
    highlighter: 'Highlighter',
    strokeWidth: 'Stroke width',
    opacity: 'Opacity',
  },
  animationsPanel: {
    animationsBlock: 'Animations',
    effectsBlock: 'Effects',
    removeAll: 'Remove all',
    direction: 'Direction',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    delay: 'Delay',
    speed: 'Speed',
    duration: 'Duration',
    endDelay: 'Exit delay',
    enterOnly: 'Enter',
    enterExitBoth: 'Both',
    exitOnly: 'Exit',
    sectionMove: 'Move',
    sectionFade: 'Fade',
    sectionZoom: 'Zoom',
    directionRight: 'Right',
    directionLeft: 'Left',
    directionUp: 'Up',
    directionDown: 'Down',
    directionBottomRight: 'Down-right',
    directionBottomLeft: 'Down-left',
    directionTopRight: 'Up-right',
    directionTopLeft: 'Up-left',
  },
  historyButtons: {
    undo: 'Undo',
    redo: 'Redo',
  },
  a11y: {
    textAlign: 'Text alignment',
    verticalAlign: 'Vertical alignment',
    listFormat: 'List format',
    volume: 'Volume',
    lineStyle: 'Line style',
    zoomLevel: 'Zoom level',
    strokeCornerSettings: 'Stroke and corners',
    adminSettings: 'Admin settings',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    strikethrough: 'Strikethrough',
  },
} as const;
